<button mat-icon-button [matMenuTriggerFor]="menu" stopPropagation>
    <mat-icon svgIcon="aumico-pattern-icon-settings-vertical"></mat-icon>
</button>

<mat-menu #menu="matMenu">
    <ng-template matMenuContent>
        <ng-container *ngFor="let item of items">
            <button
                class="aum-menu-item"
                *ngIf="!item.interchangeable; else interchangeable"
                mat-menu-item
                (click)="onClick(item, $event)"
            >
                <div class="d-flex align-items-center">
                    <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                    <span>{{ item.caption | i18next }}</span>
                </div>
            </button>
            <ng-template #interchangeable>
                <ng-container *ngFor="let conditionalOption of item.conditionalOptions">
                    <button
                        class="aum-menu-item"
                        *ngIf="
                            (Array.isArray(conditionalOption.value) &&
                                checkArrayEquality(row[conditionalOption.propertyKey], conditionalOption.value)) ||
                            JSON.stringify(row[conditionalOption.propertyKey]) ==
                                JSON.stringify(conditionalOption.value)
                        "
                        mat-menu-item
                        [disabled]="conditionalOption.disabled"
                        (click)="onClick(conditionalOption, $event)"
                    >
                        <div class="d-flex align-items-center">
                            <mat-icon *ngIf="conditionalOption.icon">{{ conditionalOption.icon }}</mat-icon>
                            <span>{{ conditionalOption.caption | i18next }}</span>
                        </div>
                    </button>
                </ng-container>
            </ng-template>
        </ng-container>
    </ng-template>
</mat-menu>
